import React, { useState } from 'react';
import { useFitStore } from '../store/useFitStore';
import Card from '../components/shared/Card';
import Button from '../components/shared/Button';
import Input from '../components/shared/Input';
import VideoEmbed from '../components/shared/VideoEmbed';
import { isYoutubeUrl } from '../lib/youtube';

const Resources: React.FC = () => {
  const { user, resources, addResource, deleteResource } = useFitStore();
  const [showAdd, setShowAdd] = useState(false);
  
  const [title, setTitle] = useState('');
  const [desc, setDesc] = useState('');
  const [url, setUrl] = useState('');
  const [type, setType] = useState<'pdf' | 'video' | 'link'>('link');

  const isCoach = user?.role === 'coach';

  const handleAdd = async (e: React.FormEvent) => {
    e.preventDefault();
    await addResource({ title, description: desc, url, type });
    setShowAdd(false);
    setTitle(''); setDesc(''); setUrl('');
  };

  return (
    <div className="main-content">
      <header style={{ marginBottom: 'var(--spacing-xl)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h1 className="text-accent" style={{ fontSize: '2rem' }}>Knowledge Hub</h1>
          <p className="text-muted">Guides, videos, and tools from your coach.</p>
        </div>
        {isCoach && <Button variant="primary" size="sm" onClick={() => setShowAdd(true)}>+ New</Button>}
      </header>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-md)' }}>
        {resources.length > 0 ? resources.map(res => {
          const isVideo = res.type === 'video' || isYoutubeUrl(res.url);
          return (
          <Card key={res.id} variant="glass" padding="var(--spacing-md)">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '1.2rem' }}>{res.type === 'pdf' ? '📄' : res.type === 'video' ? '🎬' : '🔗'}</span>
                <h3 style={{ fontSize: '1.1rem', fontWeight: 800 }}>{res.title}</h3>
              </div>
              {isCoach && <button onClick={() => deleteResource(res.id)} style={{ color: 'var(--status-red)', fontSize: '0.7rem' }}>Delete</button>}
            </div>
            <p className="text-muted" style={{ fontSize: '0.85rem', marginBottom: 'var(--spacing-md)' }}>{res.description}</p>
            {isVideo ? (
              <VideoEmbed url={res.url} title={res.title} />
            ) : (
              <a href={res.url} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                <Button variant="outline" fullWidth size="sm">VIEW RESOURCE</Button>
              </a>
            )}
          </Card>
        )}) : (
          <div style={{ textAlign: 'center', padding: 'var(--spacing-xl)' }}>
            <p className="text-muted">No resources available yet.</p>
          </div>
        )}
      </div>

      {showAdd && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.9)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'var(--spacing-lg)' }}>
          <Card style={{ width: '100%', maxWidth: '450px' }}>
            <h2 style={{ marginBottom: 'var(--spacing-lg)' }}>Upload Resource</h2>
            <form onSubmit={handleAdd} style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-md)' }}>
              <Input label="Title" value={title} onChange={e => setTitle(e.target.value)} required />
              <Input label="Description" value={desc} onChange={e => setDesc(e.target.value)} isTextArea required />
              <Input label="URL" value={url} onChange={e => setUrl(e.target.value)} placeholder="https://... (YouTube embeds automatically)" required />
              {url && isYoutubeUrl(url) && (
                <div className="rounded-lg overflow-hidden border border-fit-line">
                  <VideoEmbed url={url} title="Preview" />
                </div>
              )}
              <div>
                <label style={{ fontSize: '0.7rem', fontWeight: 800, color: 'var(--text-muted)' }}>RESOURCE TYPE</label>
                <div style={{ display: 'flex', gap: 'var(--spacing-sm)', marginTop: '4px' }}>
                  {(['pdf', 'video', 'link'] as const).map(t => (
                    <Button key={t} type="button" variant={type === t ? 'secondary' : 'glass'} size="sm" onClick={() => setType(t)} style={{ flex: 1 }}>{t.toUpperCase()}</Button>
                  ))}
                </div>
              </div>

              <div style={{ display: 'flex', gap: 'var(--spacing-md)', marginTop: 'var(--spacing-md)' }}>
                <Button variant="glass" fullWidth type="button" onClick={() => setShowAdd(false)}>Cancel</Button>
                <Button variant="primary" fullWidth type="submit">Upload</Button>
              </div>
            </form>
          </Card>
        </div>
      )}
    </div>
  );
};

export default Resources;